require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/~/_core-js@2.5.1@core-js/library/modules/es7.symbol.observable.js
// module id = 622
// module chunks = 0 1